import { AppliedFilterBarOpt, FilterBarInputOpt, FilterGroup, IFilterBar } from '../../../models/utilities/filter-bar';
import { ListColumn, SelectedSort } from '../../../models/utilities/list-header';
import { PageData } from '../../../models/utilities/paged-request';
import { ApiEndpoints, GlobalConstants } from '../../../utils/app-constants';
import { AppUtils } from '../../../utils/app-utils';
import { DriverStatusMetadata } from '../enums/driver-status';

export class DriverSearchFilters implements IFilterBar {

    public paginationInfo   : PageData = new PageData(GlobalConstants.DEFAULT_PAGE_SIZE);
    public baseUrl          : string = ApiEndpoints.TRANSPORTATION_FLEET_DRIVERS_SEARCH;
    public filters          : FilterGroup[] = [];
    public appliedFilters   : AppliedFilterBarOpt[] = [];
    public requiredFilters  : AppliedFilterBarOpt[] = [];
    public columns          : ListColumn[];
    public selectedSort     : SelectedSort;
    
    constructor() {

        // Set our table columns
        this.columns = [
            new ListColumn('ID', 'employeeId', true),
            new ListColumn('Name', 'name', true),
            new ListColumn('Cell', ''),
            new ListColumn('Service Center', ''),
            new ListColumn('Status', '')
        ];

        // Create our Filter Groups
        const byDriverId    = this.buildDriverId();
        const byName        = this.buildDriverName();
        const byStatus      = this.buildStatus();
        
        this.filters.push(
            byStatus, byName, byDriverId
        );

    }

    // #region Group Builders

    private buildStatus() {        
        const byStatus = new FilterGroup('Status', 'checkboxes', 'status');
        byStatus.opts = AppUtils.enumMetadataToFilters(DriverStatusMetadata);

        byStatus.opts.forEach((itm : FilterBarInputOpt) => {
            itm.data = (itm.qsValue === 0) ? true : false;
        });

        return byStatus;
    }

    private buildDriverId() {
        const byDriverId = new FilterGroup('Driver ID', 'text', 'driverId');
        const opt1 = new FilterBarInputOpt('Driver ID', '');
        
        byDriverId.opts = [opt1];

        return byDriverId;
    }

    private buildDriverName() {
        const byDriverName = new FilterGroup('Name', 'text', 'name');
        const opt1 = new FilterBarInputOpt('Name', '');
        
        byDriverName.opts = [opt1];

        return byDriverName;
    }
    
    // #endregion

}
